import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 2 }


import editModal from './components/editModal.vue'
import dayjs from 'dayjs'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import {
  customerConversionTaskList,
  customerConversionTaskDelete
  // customerConversionTaskImportTemple
} from '@/api/gucangSales/businessRuleSetting'
import ImportBtn from '@/components/ImportBtn'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'

import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
const __default__ = { name: 'DcCosFbuCustomerChangeTask' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editModalRef = ref()

const tableRef = ref()
const queryForm = reactive({
  startTime: '',
  endTime: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await customerConversionTaskList({ ...params, appId: 'cos_fbu' })
  callBack(res)
}
const columns = computed(() => [
  { title: '客户区域', dataIndex: 'manageAreaId' },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '任务情况', dataIndex: 'msg' },
  { title: '月度', dataIndex: 'monthDate' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: { seller: string; id: any }) => {
  Modal.delete({
    onOk() {
      customerConversionTaskDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// const handleTempleExport = async () => {
//   try {
//     const res = await customerConversionTaskImportTemple()
//   } catch (error) {
//     console.log('error: ', error)
//   }
// }

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[7] || (_cache[7] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosCustomerChangeTask"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户区域"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        appId: "cos_fbu",
                        type: "search",
                        ids: queryForm.manageAreaList,
                        "onUpdate:ids": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.manageAreaList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "arkCode",
                    label: "客户负责人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.seller,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.seller) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "arkCode",
                    label: "创建人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.createBy,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.createBy) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "arkCode",
                    label: "创建时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.startTime,
                        "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.startTime) = $event)),
                        endTime: queryForm.endTime,
                        "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'manageAreaId')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 0,
                    appId: "cos_fbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'msg')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", null, "新线索数量：" + _toDisplayString(record.clueNum || 0), 1),
                    _createElementVNode("p", null, "新签约客户数量：" + _toDisplayString(record.customerContractNum || 0), 1),
                    _createElementVNode("p", null, "老成交客户新机会额：" + _toDisplayString(record.customerDealAmount || 0), 1),
                    _createElementVNode("p", null, "新成交客户数量：" + _toDisplayString(record.customerDealNum || 0), 1),
                    _createElementVNode("p", null, "新潜在客户数量：" + _toDisplayString(record.customerPotentialNum || 0), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'monthDate')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text ? _unref(dayjs)(text).format('YYYY/MM') : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 3 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_cuschangetask_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_cuschangetask_delete_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (addEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'fbu_cuschangetask_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(ImportBtn), {
                action: "/fbu/api/customerConversionTask/import",
                templateUrl: "/fbu/api/customerConversionTask/template/download",
                onSuccess: _cache[6] || (_cache[6] = ($event: any) => (success('search')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导入")
                ]),
                _: 1
              })), [
                [_directive_permission, 'fbu_cuschangetask_import_btn']
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})